import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { fmtDur, fmtTime } from "@/lib/people";
import { toast } from "sonner";

// Live clock-in status; minutes tick on screen, the server keeps the actual times.
export function ClockCard({ orgId, data, onChanged, compact = false }) {
  const [now, setNow] = useState(Date.now());
  const [busy, setBusy] = useState(false);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  const open = data.open_entry;
  const running = open ? Math.max(0, Math.floor((now - new Date(open.clock_in).getTime()) / 60000)) : 0;
  const today = data.today_minutes - (open && open.local_date === data.today ? open.minutes : 0) + (open && open.local_date === data.today ? running : 0);

  const act = async () => {
    setBusy(true);
    try {
      await api.post(`/workspace/clock/${open ? "out" : "in"}?org_id=${orgId}`);
      toast.success(open ? "Clocked out" : "Clocked in");
      onChanged();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className={`amden-card flex flex-wrap items-center gap-4 ${compact ? "mb-6 p-4" : "p-5"}`} data-testid="clock-card">
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${open ? "bg-[#3D8B65] text-white" : "bg-[#F4F6F9] text-[#1E2D44]/45"}`}>
        <Icons.Clock size={20} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-[#0B1729]" data-testid="clock-status">
          {open ? `Clocked in since ${fmtTime(open.clock_in, data.timezone)}` : "Not clocked in"}
        </div>
        <div className="text-xs text-[#1E2D44]/55">
          Today {fmtDur(today)} · this week {fmtDur(data.week_minutes - (open ? open.minutes : 0) + running)}
          {data.scheduled_today ? ` · scheduled ${data.scheduled_today}h today` : ""} · times in {data.timezone}
        </div>
      </div>
      {data.has_profile ? (
        <Button onClick={act} disabled={busy} data-testid={open ? "clock-out-btn" : "clock-in-btn"}
          className={open ? "bg-[#0B1729] text-white hover:bg-[#1E2D44]" : "bg-[#FFB000] text-[#0B1729] hover:bg-[#E69E00]"}>
          {busy ? <Icons.Loader2 className="animate-spin" size={16} /> : open ? "Clock out" : "Clock in"}
        </Button>
      ) : <span className="text-xs text-[#1E2D44]/45">You need an employee profile to clock in.</span>}
    </div>
  );
}
